module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-four"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("\n        9. CCS Reach & Segment Data (optional)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 pull-right text-right segment-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "type"
    },
    on: {
      "click": _vm.addSegment
    }
  }, [_vm._v("Add Segment")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.CSSRich.columns.length < 3,
      "type": "type"
    },
    on: {
      "click": _vm.deleteSegment
    }
  }, [_vm._v("Delete Segment")])])]), _vm._v(" "), _c('HotTable', {
    ref: "CSSRichId",
    attrs: {
      "root": _vm.CSSRichId,
      "settings": _vm.CSSRich
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n      10. CCS Size\n    ")]), _vm._v(" "), _c('HotTable', {
    ref: "CSSSizeId",
    attrs: {
      "root": _vm.CSSSizeId,
      "settings": _vm.CSSSize
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'invalid-field': (!_vm.validate['step4'])
    },
    attrs: {
      "id": _vm.checkValidate = _vm.validate['step4']
    }
  }, [_c('p', {
    staticClass: "error-msg"
  }, [_vm._v("Please add valid entry in above table.")])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77b5afca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Model-four.vue
// module id = 315
// module chunks = 1